// extracted by mini-css-extract-plugin
export default {"items":"BackButton_items__vQyCG","goBack":"BackButton_goBack__ZRCMv","backButton":"BackButton_backButton__njDPF"};